import { Typography } from "@mui/material"

export const UserProfile = () => {
    return (
        <div>
            <Typography>Profile</Typography>
        </div>
    )
}